<template>
  <base-modal :box="box" :step="step" @on-back="mixin_set_init_step">
    <search v-model.trim="search" />
    <list-scroll ref="scroll" height="380px" :border_top="true">
      <time-interval v-for="item in filter_items" :key="item.id" :item="item">
        <list-state slot="controls" :value="is_selected(item.id)" @click="toggle_select(item.id)" />
      </time-interval>
    </list-scroll>

    <i-button slot="footer-ok" size="large" type="success" :loading="is_loading" @click="save">
      {{ $t('pbx.worksheet.modal.action.child.button.ok') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base/index';
  import Search from '../../../_base/_fragments/search';
  import TimeInterval from '@pbx/components/time-conditions/_fragments/time-condition/item-collapse';
  import ListState from '@shared/components/input/input-state-toggle';
  import { StepMixin } from '../../../_base/step-mixin';
  import { TimeConditionService } from '@pbx/services/TimeConditionService';
  import { filterName } from '@shared/helpers/filter';

  export default {
    components: { BaseModal, Search, TimeInterval, ListState },
    mixins: [StepMixin],

    data() {
      return {
        is_loading: false,
        time_condition_id: null,
        search: '',
        items: []
      };
    },

    computed: {
      filter_items: function() {
        return this.items.filter(item => filterName(this.search, item.name));
      }
    },

    watch: {
      'form.params.time_condition_id': {
        handler: function(val) {
          this.time_condition_id = val;
        },
        immediate: true
      }
    },

    async created() {
      this.items = await TimeConditionService.getSelect();
      this.$refs.scroll.refresh();
    },

    methods: {
      is_selected: function(id) {
        return this.time_condition_id === id;
      },

      toggle_select(id) {
        this.time_condition_id = id;
      },

      save: function() {
        this.mixin_save_step({
          params: {
            time_condition_id: this.time_condition_id
          }
        });
        this.mixin_set_init_step();
      }
    }
  };
</script>
